import { SerializedStyles, css } from "@emotion/react"
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image"
import { setImageSize } from "../utils/image-utils"
import { fontSizeLineHeight, mediaQueries, pxToRem, weights } from "@upsun/react-component-library/src/styles/css-utils"
import { colors } from "../utils/colors"
// import { IconComponent } from "../icons"

type AuthorProps = {
  name: string,
  title: string,
  company?: string,
  image: IGatsbyImageData,
  css?: SerializedStyles
}

const Author:React.FC<AuthorProps> = ({
  name,
  title,
  company,
  image,
  ...props
}) => {
  const authorWrapperStyles = css`
    display: flex;
    flex-direction: row;
    align-content: center;

    ${mediaQueries.lg} {
      text-align: center;
      flex-direction: column;
      align-items: center;
    }

    margin-bottom: 24px;
  `
  // fix for border radius in Safari: https://stackoverflow.com/questions/70090950/css-border-radius-doesnt-work-in-safari-after-switching-to-gatsby-plugin-image
  const authorImgStyles = css`
    width: ${pxToRem(80)};
    min-width:${pxToRem(80)};
    height: ${pxToRem(80)};
    border-radius: 50%;
    mask-image: radial-gradient(white, black);
    -webkit-mask-image: -webkit-radial-gradient(white, black);
    ${mediaQueries.lg} {
      width: ${pxToRem(80)};
      height: ${pxToRem(80)};
    }
  `;

  const authorInfoWrapper = css`
    display: flex;
    flex-direction: column;
    justify-content: center;

    margin: 0 0 0 ${pxToRem(24)};
    align-items: flex-start;

    ${mediaQueries.lg} {
      align-items: center;
      margin: auto;
    }

    ${mediaQueries.xl} {
      margin-top: ${pxToRem(24)};
    }
  `;

  const authorNameStyles = css`
    ${fontSizeLineHeight(18, 28)};
    font-weight: ${weights.bold};
  `

  return (
    <div {...props} css={authorWrapperStyles}>
      <GatsbyImage
        css={authorImgStyles}
        image={setImageSize(image, "headshotLarge") as IGatsbyImageData}
        alt={name || ""}
      />
      <div css={authorInfoWrapper}>
        <div 
          css={authorNameStyles} 
          dangerouslySetInnerHTML={{ __html: name }} 
        />
        <div>{title}</div>
        {company ? <div>{company}</div> : ""}
      </div>
    </div>
  )
}

export { Author }
